import { createSelector } from 'reselect'
import { userSelector } from '../auth/selectors'

export const retailerAccountsSelector = (state) => state.retailerAccounts

export const userRetailerAccountsSelector = createSelector(
  [userSelector],
  (user) => {
    return (user && user.retailer_accounts) || []
  },
)

export const retailerAccountsByIdSelector = createSelector(
  [userRetailerAccountsSelector],
  (userRetailerAccounts) => {
    return userRetailerAccounts.reduce((map, retailerAccount) => {
      map[retailerAccount.id] = retailerAccount
      return map
    }, {})
  },
)

export const retailerAccountsBySlugSelector = createSelector(
  [retailerAccountsSelector],
  (retailerAccounts) => {
    const retailerAccountsBySlug = {}
    for (let id in retailerAccounts) {
      let retailerAccount = retailerAccounts[id].retailerAccount
      if (retailerAccount) {
        retailerAccountsBySlug[retailerAccount.slug] = retailerAccount
      }
    }
    return retailerAccountsBySlug
  },
)
